import { render, staticRenderFns } from "./SurveyWelcomeInfo.vue?vue&type=template&id=d433b780&"
import script from "./SurveyWelcomeInfo.vue?vue&type=script&lang=js&"
export * from "./SurveyWelcomeInfo.vue?vue&type=script&lang=js&"
import style0 from "./SurveyWelcomeInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports